import React from 'react';
import {useTranslation} from "react-i18next";
import {Modal} from "antd";
import {Text} from "../../index";
import {CloseIcon, BrowserRecordsExtenImg} from "../../../image";
import {Button} from "../../Button";
import './BrowserExtensionModal.scss';
import {GetExtensionLinkService} from "../../../redux/actions";

const BrowserExtensionModal = ({open, onClose}) => {
    const {t} = useTranslation();

    const onCloseModal = () => {
        onClose();
    }

    const onClickInstall = async () => {
        const response = await GetExtensionLinkService();
        window.open(response?.link, '_blank');
        onClose();
    }

    return (
        <Modal
            classNames={{
                wrapper: 'welcome_modal__wrapper',
            }}
            open={open}
            onCancel={onCloseModal}
            centered
        >
            <div className="extension_modal__container">
                <div className="extension_modal__header">
                    <Text size="f22" font="medium">{t('browser_extension')}</Text>
                    <CloseIcon onClick={onCloseModal}/>
                </div>
                <img src={BrowserRecordsExtenImg}
                     className="extension_modal__container--img"/>
                <Text size="f18" font="medium" as="p" className="extension_modal__container--title">{t('browser_extension_subtitle')}</Text>
                <div className="extension_modal__container--desc">
                    <Text size="f16" font="liteMedium" as="p" color="#828282">
                        {t('browser_extension_desc')}
                    </Text>
                </div>
                <div className="extension_modal__container--buttons">
                    <Button
                        text={t('install')}
                        onClick={onClickInstall}
                    />
                </div>
            </div>
        </Modal>
    );
};

export default BrowserExtensionModal;